/*------------------------------------------------------------------ 
Import scripts
------------------------------------------------------------------*/

import { $, $$ } from '../utilities/helpers';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { ENDPOINTS } from '@/components/constants';
import { PinchZoom } from '@/components/pinchZoom';

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

function printPDF(url) {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

    if (isStandalone) {
        // Fetch the PDF and force download
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(blobUrl);
            })
            .catch(error => {
                console.error('Download failed:', error);
            });
    } else {
        // Browser mode: Open and print when ready (using polling)
        const printWindow = window.open(url, '_blank');
        if (!printWindow) return;

        const checkReady = setInterval(() => {
            try {
                if (printWindow.document && printWindow.document.readyState === 'complete') {
                    clearInterval(checkReady);
                    printWindow.focus();
                    printWindow.print();
                }
            } catch (e) {
                // Ignore cross-origin errors until it loads
            }
        }, 300);
    }
}

if ($('.js-print-resource')) {
    $('.js-print-resource').addEventListener('click', function (event) {
        event.preventDefault();
        printPDF(event.target.href);
    });
}

if ($$('.zoomable-image-wrapper')) {
    $$('.zoomable-image-wrapper [zoomable]').forEach(element => {
        console.log('ZOOM PICK - IMAGES');
        console.log(element)
        
        let zoomPick = new PinchZoom(element);
    });
}


if ($('.js-email-resource')) {
    $('.js-email-resource').addEventListener('click', function (event) {
        event.preventDefault();

        Swal.fire({
            title: '<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M792-696H168v419.69q0 5.39 3.46 8.85t8.85 3.46H536q11.07 0 18.54 7.4 7.46 7.41 7.46 18.39t-7.46 18.59Q547.07-212 536-212H180.31Q154-212 135-231q-19-19-19-45.31v-407.38Q116-710 135-729q19-19 45.31-19h599.38q27.01 0 45.66 19Q844-710 844-683.69V-448q0 11.07-7.41 18.54-7.4 7.46-18.38 7.46-10.98 0-18.59-7.46Q792-436.93 792-448v-248Zm-624 0v432-168.61 2.53V-696Zm312 179 312-179v62.69L497.08-463.77q-7.98 4.61-16.45 4.61-8.48 0-16.71-4.61L168-630.23V-696l312 179Zm310.16 305H652.24q-11.04 0-18.49-7.41-7.44-7.4-7.44-18.38 0-10.98 7.44-18.59 7.45-7.62 18.49-7.62h138.3l-49.17-49.17q-7.68-7.68-8.06-18.33-.39-10.65 7.92-19.06 7.92-7.82 18.58-7.44 10.65.38 18.39 8.15l89.16 89.36q5.02 5.04 7.64 10.59 2.61 5.56 2.61 12.02 0 6.07-2.61 11.82-2.62 5.75-7.23 10.37L778-125.92q-8.31 8.3-18.08 7.42-9.77-.89-17.69-8.81-8.31-8.31-8.31-18.19 0-9.89 8.31-18.19L790.16-212Z"></path></svg>Email this resource',
            html:/*html*/`<p class="no-margin">Share this resource with a patient or colleague</p>`,
            input: "email",
            inputPlaceholder: "Enter an email address"
        }).then((result) => {
            if (result.value) {
                const url = new URL(ENDPOINTS.SHARE_RESOURCE);
                fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ recipient: result.value, resource_id: event.target.dataset.id })
                })
                    .then(response => response.json())
                    .then((data) => {
                        if (data.status === 'ok') {
                            Toast.fire({
                                icon: 'success',
                                title: 'Resource shared'
                            })
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: 'Resource not shared'
                            })
                        }
                    })
            }
        })
    });
}

